import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, contains, union, exclude } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnasFijas } from "./columns";
import { Multiselector } from "app/features/componentes/multiselector";

type Entity = models.ClientePendienteDto;
export interface Props {
    /**Ids de los clientes seleccionados */
    value: number[];
    onChange: (value: number[]) => PromiseLike<void> | void;
    items: Entity[];

}

/**
* Listado de 
*/
class MultiClienteListNoRx extends React.PureComponent<Props> {

    render() {
        const cols = columnasFijas;
        return (
            <div>
                <Multiselector
                    value={this.props.value}
                    onChange={this.props.onChange}
                    items={this.props.items} 
                    getKey={(x: Entity) => x.IdCliente}
                    columnas={cols}
                    hideBusqueda
                />
            </div>
        );
    }
}
export const ClienteMultiselectorList = kea.mapProps(componentToRx(MultiClienteListNoRx), x => ({ ...x, value: x.value || [] }));



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/modales/nuevoviaje/multicliente/listmem.tsx